export default __webpack_public_path__ + "static/media/Logo.f568a0a7.png";